//import axios from "axios"
//import store from "@/store";

export default {
    // чтобы названия были локальные
    namespaced: true,

    state: {
        dateAction: '',
    },
    getters: {
        dateAction(state){
            return state.dateAction
        },
    },
    mutations: {
        setDateAction(state, data){
            state.dateAction = data
        },
        initDateAction(state){
            state.dateAction = ''
        },
    },
    actions: {
    },
}